module.exports = __webpack_public_path__ + "img/Parallax.9e2d47bc.jpg";